export default __webpack_public_path__ + "static/media/correctional.26b05f1e.jpg";